import { Component, Input } from '@angular/core';
import { BreadcrumbComponent } from '../../breadcrumb/breadcrumb.component';

@Component({
  selector: 'cap-spinner-small',
  templateUrl: './cap-spinner-small.component.html',
  styleUrls: ['./cap-spinner-small.component.scss'],
  imports: [BreadcrumbComponent]
})
export class CapSpinnerSmallComponent {
  @Input()
  withBreadcrumb = false;
}
